import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export const LegalBody = ({ body }) => (
  <div className="space-y-2 text-sm leading-relaxed text-slate-700">
    {body.split("\n").map((l, i) => {
      if (l.startsWith("## ")) return <h3 key={i} className="pt-3 font-display text-base font-semibold text-slate-900">{l.slice(3)}</h3>;
      if (l.startsWith("- ")) return <li key={i} className="ml-5 list-disc">{l.slice(2)}</li>;
      return l.trim() ? <p key={i}>{l}</p> : null;
    })}
  </div>
);

export default function LegalDoc() {
  const { docKey } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/legal/${docKey}`).then((r) => setD(r.data)).catch(() => setD(false)); }, [docKey]);
  if (d === false) return <div className="p-10 text-sm text-slate-500">Document not found.</div>;
  if (!d) return null;
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <article className="mx-auto max-w-3xl rounded-lg border border-slate-200 bg-white p-6 md:p-10" data-testid={`legal-doc-${docKey}`}>
        <h1 className="font-display text-2xl font-bold text-slate-900">{d.title}</h1>
        <div className="mt-1 text-xs text-slate-500">Version {d.version} · updated {d.updated_at?.slice(0, 10)}</div>
        {d.draft && <div className="mt-4 flex gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-xs text-amber-900" data-testid="legal-draft-banner"><AlertTriangle className="h-4 w-4 shrink-0" />{d.banner}</div>}
        <div className="mt-4"><LegalBody body={d.body} /></div>
        <div className="mt-8 flex gap-4 text-xs text-blue-700">{["disclosure", "terms", "privacy", "dpa"].filter((k) => k !== docKey).map((k) => <Link key={k} to={`/legal/${k}`} className="underline">{k === "dpa" ? "Data Processing Agreement" : k[0].toUpperCase() + k.slice(1)}</Link>)}</div>
      </article>
    </div>
  );
}
